import { NoiseGenerator } from './noise';

export function isCave(noise: NoiseGenerator, wx: number, wy: number, wz: number): boolean {
  if (wy <= 1 || wy >= 128) return false;

  const cave = noise.octave3D(wx, wy, wz, 2, 0.5, 2.0, 0.05);
  const threshold = 0.55 - (wy < 20 ? (20 - wy) * 0.005 : 0);

  return Math.abs(cave) > threshold;
}
